import React, { useRef, useEffect } from 'react'
import lottie from 'lottie-web'
import Page from '../common/Page'

import { CTAButton } from '../common/Button'
import { Title, SubTitle, Copyright } from '../common/Text'

const ctaStyle = {    
    width: '100%',
    height: '3.5rem',    
    position: 'relative'
}

const arrowStyle = {    
    position: 'absolute',
    top: 0, 
    bottom: 0,
    right: 0,        
    margin: 'auto',
    marginRight: '0.75rem',
    width: '2rem',
    height: '2.5rem'    
}

export default function Intro(props) {
    const lottieContainer = useRef()  
    const lottieContainerArrow = useRef()  

    useEffect(() => {
        lottie.loadAnimation({           
            container: lottieContainer.current,                       
            animationData: require('../../assets/book.json')
        })        
        lottie.loadAnimation({           
            container: lottieContainerArrow.current,                       
            animationData: require('../../assets/ic_next.json')
        })     
    },[])

    return (
        <Page>            
            <Title style={{paddingTop: '5rem'}}>Bible Verse<br/>for Your Mood</Title>
            <div ref={lottieContainer} style={{marginTop: '0.75rem'}}/>
            <SubTitle style={{marginTop: '2.5rem', marginBottom: '0.75rem'}}>What is God Telling You Today?</SubTitle>            
            <CTAButton style={ctaStyle} onClick={props.nextStep}>
                START
                <div ref={lottieContainerArrow} style={arrowStyle}/>
            </CTAButton>                    
            <Copyright style={{marginBottom: '1.5rem'}}>Powered by. Daily Bible</Copyright>
        </Page>
    )
}